import type { AgentRun } from '@/api/proposals/proposals'

export function proposalBuildNeedsFreshRun(run: AgentRun): boolean {
  // Retry keeps the original source snapshot. Source recovery must validate a new
  // snapshot; a fresh proposal build still preserves already-drafted sections.
  return (
    run.workflowKind === 'proposal-build' &&
    run.status === 'failed' &&
    (run.failureCode === 'source_required' || run.failureCode === 'source_changed')
  )
}
